import React from 'react';
import { useTranslation } from 'react-i18next';
import './BrandBadges.scss';

interface BrandBadgesProps {
  /** Marka projektu (`defaultKeyword`). */
  isMain?: boolean;
  /** Marka wybrana do analizy na dashboardzie (`firmName`). */
  isSelected?: boolean;
}

/** Plakietki „Marka główna” / „Wybrana marka” przy nazwie marki — Brands i Ranking marek. */
export const BrandBadges: React.FC<BrandBadgesProps> = ({ isMain = false, isSelected = false }) => {
  const { t } = useTranslation();
  if (!isMain && !isSelected) return null;

  return (
    <span className="brand-badges">
      {isMain && <span className="brand-badges__badge">{t('brandProjectBadge')}</span>}
      {isSelected && (
        <span className="brand-badges__badge brand-badges__badge--secondary">{t('brandSelectedBadge')}</span>
      )}
    </span>
  );
};

export default BrandBadges;
